import QS from 'qs';
import _ from 'lodash';

import { getDateRangeFilter } from 'utils/filter-utils';
import Rest from 'services/data/rest';
import store from 'app-store';

export default class TimeReport extends Rest {
  static path = 'timereport';
  static defaultQuery = {
    sort: 'date DESC',
    load: ['rate', 'ticket.agreement', 'agreement.rates', 'company']
  };

  static mapFilters(filters) {
    const {
      company,
      date,
      multiAgreement,
      createdBy,
      id,
      search,
      team
    } = filters;

    // If the id filter is applied, ignore all other filters
    // (and turn off the api's default status filtering)
    if (id) return { id, status: { '!': null } };

    return {
      'agreement.company': company,
      'agreement.company.team': team,
      agreement: multiAgreement ? { in: multiAgreement } : undefined,
      date: getDateRangeFilter(date),
      createdBy: createdBy ? { in: createdBy } : undefined,
      search,
      id
    };
  }

  static getExportUrl(query) {
    const auth = store.getState().auth;
    const params = _.assign({ access_token: auth.token }, query);
    const queryString = QS.stringify(params, { strictNullHandling: true });

    return `/api/timereport/export?${queryString}`;
  }

  static getExportActionsUrl(query) {
    const auth = store.getState().auth;
    const params = _.assign({ access_token: auth.token }, query);
    const queryString = QS.stringify(params, { strictNullHandling: true });

    return `/api/timereport/export-actions?${queryString}`;
  }

  static getTotal(timeReports) {
    return _.reduce(timeReports, (total, report) =>
      total + Number(report.duration)
    , 0);
  }

  static isBillable(report) {
    const { rate, afterHours, amount } = report;
    const hasRate = rate && !_.isEmpty(rate);

    return !!(Number(amount) && (hasRate || afterHours));
  }
}
